import $ from 'jquery';

console.log('slick-offerte.js');

class carouselSliderOfferte {
  constructor() {
    this.sliderOfferte = $('.vetrina-offerte .ecs-posts');
    this.initCarousel();
  }

  initCarousel() {
    this.sliderOfferte.slick({
      autoplay: true,
      autoplaySpeed: 4000,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      adaptiveHeight: true,
      centerMode: true,
      centerPadding: '2em',
      fade: false,
      mobileFirst: false,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  }
}

export default carouselSliderOfferte;
